module.exports = __webpack_public_path__ + "img/Coleman.50ed3fb4.jpg";